import type { GetAllPracticesResponse } from "@/core/types/(api)/practice";

export function adaptIntakePracticeOptions(practices: GetAllPracticesResponse) {
  return practices
    .filter((p) => p.practice_type === "Primary Care")
    .map((p) => ({ id: p.id, name: p.name }));
}
